import { Selection, select } from "d3";
import '../../../styles/components/ConfirmDialog.scss';
import _L from "../../utils/Labels";
import { AppButton } from "../components-lit/Buttons/AppButton";
import { RadioGroup } from "./RadioButton";

export class ConfirmDialog {

    private divDialog: Selection<HTMLDivElement, any, any, any>;
    private dTexts: Selection<HTMLDivElement, any, any, any>;
    private txtTitle: Selection<HTMLHeadingElement, any, any, any>;

    private radOptions: RadioGroup;

    private OnCancel?: () => void;
    private OnConfirm?: (val: any) => void;

    constructor() {
        this.divDialog = select("body")
            .append("div").classed("dlg-confirm", true);
        this.CreateDialog();
    }

    private CreateDialog() {
        const dialogContainer = this.divDialog.append("div").classed("dialog-container", true);
        this.dTexts = dialogContainer.append("div").classed("text-container", true)
        this.txtTitle = this.dTexts.append("div").attr("class", "title-container hide")
            .append("h1").classed("title", true).style("display", "none")
        this.dTexts.append("h2").classed("subtitle", true);

        const footer = dialogContainer.append("div").classed("footer", true);

        // Cancel button (app-button)
        const btnCancel: AppButton = document.createElement('app-button');
        btnCancel.label = _L("general.cancela");
        btnCancel.className = 'btn-dialog-footer left';
        btnCancel.addEventListener('click', () => {
            this.OnDestroy();
            if (this.OnCancel) this.OnCancel();
        });
        footer.node().appendChild(btnCancel);

        // Accept button (app-button)
        const btnAccept: AppButton = document.createElement('app-button');
        btnAccept.label = _L("general.acepta");
        btnAccept.className = 'btn-dialog-footer right';
        btnAccept.addEventListener('click', () => {
            let valSelected: any;
            if (this.radOptions) {
                valSelected = this.radOptions.GetRadioSelectedInfo();
                if (!valSelected) return;
            }

            this.OnDestroy();

            if (this.OnConfirm) this.OnConfirm(valSelected);
        });
        footer.node().appendChild(btnAccept);
    }

    public Dismiss() {
        this.divDialog.remove();
    }

    public SetTitle(val: string): ConfirmDialog {
        this.txtTitle.style("display", "block")
            .text(val);

        this.dTexts.select(".title-container").classed("hide", !val);

        return this;
    }

    public SetDescription(description: string): ConfirmDialog {
        this.divDialog.select(".dialog-container").select(".subtitle")
            .text(description)
        return this;
    }

    public AddRadioOptions(list: any[], propValue?: string, removeDescription = true): ConfirmDialog {
        removeDescription && this.dTexts.select(".subtitle").style('display', 'none');

        this.radOptions = new RadioGroup(this.dTexts, "type-comment");
        list.forEach((item, i) => {
            const label = propValue ? item[propValue] : item.label;
            this.radOptions.AddRadioButton()
                .SetIdentifier("" + i)
                .SetLabel(label)
                .SetValue(item);
        });

        return this;
    }

    public SetOnCancel(completion: () => void) {
        this.OnCancel = completion;
    }

    public SetOnConfirm(completion: (val: any) => void) {
        this.OnConfirm = completion;
    }

    public GetDialogElement() {
        return this.divDialog;
    }

    public OnDestroy() {
        // animacion de salida
        this.divDialog.style("animation", "fadeOut 0.3s ease-in-out");
        setTimeout(() => {
            this.divDialog.remove();
        }, 300);
    }

}